module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_1.d59c3682.png";